<a
  [href]="href || '#'"
  [ngClass]="['ui-button', 'variant-' + variant, 'size-' + size]"
>
  <ng-content></ng-content>
</a>
